import React from 'react'; 
import { Helmet } from 'react-helmet-async';
import Certificates from '../Certificates';
import All_Program_Mentor from '../All_Program_Mentor';
import Counsellor from '../Counsellor';
import Html_css_curriculum_page from './Html_css_curriculum_page';
import Html_css_Review_Program_Page from './Html_css_Review_Program_Page';
import Html_css_FAQ_page from './Html_css_FAQ_page';
import Htmlcss1 from "../image/Htmlcss1.jpg"


function Html_css() {
   
  const canonicalUrl = 'https://www.internselite.net/Html-CSS'; 
  return (
    <>
    <style>{`
       .Html_css_image{
          background-image: url(${Htmlcss1});
          background-repeat: no-repeat;
          background-size: cover;
          z-index:-1 !important;
        }
        .Html_css_image .background_color{
          background-image: linear-gradient(rgb(7, 7, 7,0.5), rgba(7,7,7,0.7));
          width:100%;
        }
      `}</style>
    <div>
    <Helmet>
        <title>Android App Development Course | InternsElite: Build Android Applications</title>
        <meta name='description' content='Join InternsElite’s Android App Development course to learn how to build Android applications. Gain hands-on experience with Android Studio and Java, and earn a professional certification. Advance your career in mobile app development.' />
        <meta name='keywords' content='android app development, mobile development, online training, certification course, professional courses, android certification' />
        <meta property="og:title" content="Android App Development Course | InternsElite: Build Android Applications" />
        <meta property="og:description" content="Join InternsElite’s Android App Development course to learn how to build Android applications. Gain hands-on experience with Android Studio and Java, and earn a professional certification. Advance your career in mobile app development." />
        <meta property="og:url" content="https://internselite.net/Html-CSS" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@internselite" />
        <meta name="twitter:title" content="Android App Development Course | InternsElite: Build Android Applications" />
        <meta name="twitter:description" content="Join InternsElite’s Android App Development course to learn how to build Android applications. Gain hands-on experience with Android Studio and Java, and earn a professional certification. Advance your career in mobile app development." />
        <meta name="twitter:image" content="https://internselite.net/static/media/logo.c1eb8ff81ef75599f376.png" />
        <link rel="canonical" href={canonicalUrl} />
    </Helmet>


    {/* -----------------Mobile View-------------------- */}
    <div className='Html_css_image d-sm-block d-md-none'>
        <div className='container-fluid background_color py-5'>
            <div className='row mt-5'>
              <div className='col-md-12'>
                <div className='Details_Main_text'>
                  <h1 className='display-6 pt-5  text-white'>Android App Development Traineeship Program</h1>
                  <h4 className='text-white pt-2'>Start Learning Android App Development by Top Industry Experts...</h4>
                  <a href='#AAD'><button className="text-white shadow-sm my-4 fs-5 px-4 pt-1 pb-2 Pr_details_button">Read More...</button></a>
              </div>
              </div>
            </div>
        </div>
    </div>

    {/* -------------------------Desktop View----------------- */}
    <div className='Html_css_image d-none d-md-block mt-5'>
        <div className='container-fluid background_color py-5'>
              <div className='mt-5'>
                <div className='px-5 py-5 Details_Main_text'>
                  <h1 className='display-5 mt-5 pt-5 text-white'>HTML/CSS Coding Camp Program</h1>
                  <h4 className='text-white pt-2'>Start Learning Hypertext Markup Language and Cascading Style Sheets by Top Industry Experts...</h4>
                  <a href='#AAD'><button className="text-white shadow-sm my-4 fs-5 px-4 pt-1 pb-2 Pr_details_button">Read More...</button></a>
              </div>
              </div>
        </div>
    </div>

    <div id='AAD' className='py-5'><Html_css_program_details/></div>
    <div className='Curriculum_Containte_box py-5'>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-md-2'></div>
          <div className='col-md-8'>
          <div className='text-center Curriculum_Main_text'>
                <h1 className='display-6 pb-2'>Program Curriculum</h1>
                <p className='px-2'>A comprehensive and dynamic syllabus designed to empower your skills and propel your success in every aspect of your professional and personal development.</p>
            </div>
          </div>
          <div className='col-md-2'></div>
        </div>
        <div className='row'>
          <div className='col-md-1'></div>
          <div className='col-md-10'>
          <div className='mt-3'>
            <Html_css_curriculum_page/>
          </div>
          <div className='col-md-1'></div>
          </div>
        </div>
      </div>
    </div>

    <Certificates/>
    {/* <All_Program_Mentor/> */}
    <Html_css_Review_Program_Page/>
    <Html_css_FAQ_page/>
    <Counsellor/>
    </div>
    </>
  )
}

function Html_css_program_details(){
  return(
    <>
    <div>
      {/* ------------------Mobile View--------------- */}
      <div className="d-sm-block d-md-none">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center Program_details_1stcomp_text_mobile">
                <h1 className="display-6">Mastering Android Wonders!</h1>
                <p className="py-2">
                  Dive into the world of Android programming with our dynamic
                  course. Unlock the secrets of app development. Enrol now for a
                  bright future in tech innovation!
                </p>
              </div>
              <div className="mt-4 text-center Program_details_1stcomp_text_mobile">
                <h1 className="display-4">Overview</h1>
                <p className="py-2">
                  Embark on a dynamic journey into Android development with our
                  comprehensive Training Internship. Delve into live projects
                  guided by industry experts, covering the entire Android
                  development spectrum. From foundational concepts to advanced
                  Flutter applications, gain hands-on experience in UI/UX, form
                  creation, and navigation. Elevate your skills through a robust
                  curriculum, earning three major certified certificates upon
                  completion. Propel your career with internship and placement
                  opportunities, ensuring you're equipped to thrive in the
                  evolving world of Android development. Let's start your
                  transformative learning experience!
                </p>
              </div>
            </div>
            <div className="col-md-12">
              <div>
                <div className=" Details_container shadow-lg px-1 py-4">
                  <h1 className="Details_text text-center  pb-2 border-bottom">
                    Android App Development
                  </h1>
                  <div className="mobile_view_Details_text">
                    <ul className="pt-2">
                      <li>Learn from live expert sessions with industry professionals</li>
                    <li className="py-3">Project support and guidance</li>
                    <li>Access exclusive program material </li>
                    <li className="py-3">25+ learning hours</li>
                    <li>
                      Certification to boost your career profile and achieve growth & success                     
                    </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* -------------------------Desktop view----------------------- */}
      <div className="d-none d-md-block">
        <div className="container">
          <div className="row">
            <div className="col-md-8 detail_1stcomp_img">
              <div className="pt-3 Program_details_1stcomp_text">
                <h1 className="fs-2">Mastering Android Wonders!</h1>
                <p className="py-2">
                  Dive into the world of Android programming with our dynamic
                  course. Unlock the secrets of app development. Enrol now for a
                  bright future in tech innovation!
                </p>
              </div>
              <div className="mt-3 Program_details_1stcomp_text">
                <h1 className="display-4">Overview</h1>
                <p className="py-2">
                  Embark on a dynamic journey into Android development with our
                  comprehensive Training Internship. Delve into live projects
                  guided by industry experts, covering the entire Android
                  development spectrum. From foundational concepts to advanced
                  Flutter applications, gain hands-on experience in UI/UX, form
                  creation, and navigation. Elevate your skills through a robust
                  curriculum, earning three major certified certificates upon
                  completion. Propel your career with internship and placement
                  opportunities, ensuring you're equipped to thrive in the
                  evolving world of Android development. Let's start your
                  transformative learning experience!
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div>
                <div className=" Details_container shadow-lg px-3 py-4">
                  <h1 className="Details_text text-center  pb-4 pt-3 border-bottom">
                    Android App Development
                  </h1>
                  <div className="Details_text ">
                    <ul className="pt-3">
                       <li>Learn from live expert sessions with industry professionals</li>
                    <li className="py-3">Project support and guidance</li>
                    <li>Access exclusive program material </li>
                    <li className="py-3">25+ learning hours</li>
                    <li>
                      Certification to boost your career profile and achieve growth & success                     
                    </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}
export default Html_css
